import React from 'react';
import { Checkbox } from '../../ForBrands/ui/BrandUI';

// Pieces the V2 Users table and the Assign players dialog share.

// The Users table's ReactPaginate class set: rounded pill pages, the active
// page filled in n700. The pills wrap on a phone instead of pushing the
// Next pill past the edge.
export const USERS_PAGINATE_CLASSES = {
  containerClassName: 'flex flex-wrap items-center gap-1 bm-label-xs',
  pageClassName: 'rounded-full border border-bm-border',
  pageLinkClassName: 'inline-flex h-8 min-w-[32px] items-center justify-center px-2 text-bm-ink',
  activeClassName: '!border-bm-n700 bg-bm-n700 text-white',
  activeLinkClassName: 'text-white',
  previousClassName: 'rounded-full border border-bm-border',
  previousLinkClassName: 'inline-flex h-8 items-center justify-center px-3 text-bm-ink',
  nextClassName: 'rounded-full border border-bm-border',
  nextLinkClassName: 'inline-flex h-8 items-center justify-center px-3 text-bm-ink',
  breakLinkClassName: 'inline-flex h-8 items-center justify-center px-2 text-bm-tertiary',
  disabledClassName: 'opacity-40 cursor-not-allowed',
};

// The BrandUI Checkbox for a table cell: no visible text, `label` is its
// aria-label. A select-all passes `indeterminate` while only some rows on the
// page are ticked.
export const RowCheckbox = ({ checked, onChange, label, indeterminate = false }) => (
  <Checkbox
    checked={!!checked}
    onChange={onChange}
    aria-label={label}
    indeterminate={indeterminate}
  />
);
